<template>
  <div id="app" :class="isAllGray ? 'wrapperImg' : ''">
    <router-view v-if="isRouterAlive"></router-view>
    <!-- <div v-if="Weixin == true" class="open-bg">
      <img src="./assets/arrows.png" class="arrows" />
      <img src="./assets/message.png" class="message" />
    </div> -->
    <!-- <router-view v-if="isRouterAlive && Weixin == false"></router-view> -->
  </div>
</template>
<script>
import service from "./service/index";
export default {
  provide() {
    //父组件中通过provide来提供变量，在子组件中通过inject来注入变量。
    return {
      reload: this.reload,
    };
  },

  data() {
    return {
      isRouterAlive: true,
      isAllGray: false, // 是否置灰
      Weixin: false, //是否是微信浏览器
    };
  },
  mounted() {
    setInterval(() => {
      document
        .querySelector("body")
        .setAttribute("style", "overflow: auto !important;");
    }, 1000);
  },
  created() {
    // console.log("isWeixin", this.isWeixin());
    // if (this.isWeixin()) {
    // } else {
    // }
    this.getVisitorNum();
    this.getGraySetting();
  },
  methods: {
    reload() {
      this.isRouterAlive = false; //先关闭，
      this.$nextTick(() => {
        this.isRouterAlive = true; //再打开
      });
    },
    // 访客
    getVisitorNum() {
      // localStorage.clear();
      service.getVisitor({}, (res) => {
        localStorage.setItem("visitorNum", res);
      });
    },
    // 是否全局置灰
    getGraySetting() {
      service.setAllGray({}, (res) => {
        this.isAllGray = res;
      });
    },
    isWeixin() {
      var ua = navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        this.Weixin = true;
        return true;
      } else {
        this.Weixin = false;
        return false;
      }
    },
  },
};
</script>

<style >
html,
body {
  overflow-y: auto !important;
  overflow-x: hidden;
}
.wrapperImg {
  -webkit-filter: grayscale(100%);
  filter: Gray;
}
#app {
  width: 100%;
  overflow: hidden;
}
.open-bg {
  width: 100%;
  min-height: 100vh;
  background-color: rgba(0, 0, 0, 0.8);
  position: relative;
  display: flex;
  justify-content: center;
}
.arrows {
  position: absolute;
  top: 20px;
  right: 30px;
}
.message {
  position: absolute;
  top: 100px;
}
</style>